import {
  TeacherMarkFragment,
  TeacherClassFragment,
  TeacherClassStudentFragment,
  TeacherClassStudentsQueryVariables,
} from '@school_ify/schoolify-repository/src/teacher/types';
import {
  teacherGetClasses,
  teacherGetClassStudents,
} from '@school_ify/schoolify-repository/src/teacher/repositories/classRepository';

class TeacherClassesService {
  marks: TeacherMarkFragment[];

  constructor(marks: TeacherMarkFragment[]) {
    this.marks = marks;
  }

  public async getTeacherClasses(): Promise<Array<TeacherClassFragment>> {
    try {
      // @ts-ignore
      const classes = await teacherGetClasses();
      return classes;
    } catch (err) {
      return err;
    }
  }

  public async getClassStudentsFromTeacher(
    variables: TeacherClassStudentsQueryVariables
  ): Promise<Array<TeacherClassStudentFragment>> {
    try {
      const students = await teacherGetClassStudents(variables);
      // @ts-ignore
      return students;
    } catch (err) {
      return err;
    }
  }
}

export default new TeacherClassesService([]);
